import React, { useEffect } from "react";
import { convertDateTime, getImageUrl } from "../../../utils/generalLiveCenter";
import { DateUtility } from "../../../utils/dateUtility";
import NextImage from "../../common/NextImage";
import NoDataFound from "../../common/NoDataFound";
import MatchScores from "../../common/football/MatchScores";
import { MatchOptions } from "../../../utils/matchOptions";
import { loadStyles } from "../../../utils/cssLoader";

const Matches = ({
  data,
  difference,
  matchType,
  loadCSS,
  sport,
  setDataId,
  setDataType,
  setHead,
  setLeagueId,
}) => {
  const handleClick = async (sport, match) => {
    setDataId(match?.id);
    setDataType("match-page");
    setHead("match");
  };

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("leaguepage");
    }
  }, [loadCSS]);
  if (!data) {
    return <h3>Loading...</h3>;
  }
  if (!data || (data && data?.length === 0)) {
    return (
      <div className="leg_wrp">
        <div className="leg_box">
          <div className="text-center">
            <NoDataFound />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="leg_wrp">
      <div className="leg_box">
        {matchType === "upcoming" && !data[0]?.nm && (
          <div className="leg_head">
            <h2>
              <span className="name">Upcoming Matches</span>
            </h2>
          </div>
        )}
        {data?.map((league) => (
          <React.Fragment key={league?.lid}>
            {matchType === "finished" &&
              league?.matches[0].competitors !== null &&
              !league?.lid && (
                <div className="leg_head">
                  <h2>
                    <span className="name">{convertDateTime(league?.d)}</span>
                  </h2>
                </div>
              )}
            {league?.lid && (
              <div
                className="leg_head "
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setDataId(league?.id);
                  setDataType("league-page");
                  setHead("league");
                  setLeagueId(league?.id);
                }}
              >
                <div className="team_head">
                  <div class="league_logo">
                    <NextImage
                      src={`${process.env.REACT_APP_BASE_URL}/public/assets/images/flags/country_${league?.fid}.png`}
                      height={23}
                      width={23}
                      alt="teamLogo"
                      priority={false}
                    />
                  </div>
                  <h2>
                    <span className="name">{league?.nm}</span>
                  </h2>
                </div>
              </div>
            )}
            {league?.matches.map((match) => {
              let score = MatchOptions?.footballFTStatuses?.includes(match?.st?.toLowerCase())
                ? match?.ft
                : match?.cfs;
              let winner = score;
              if (match?.mins === "FAP") {
                winner = match?.ps;
              }
              return (
                <>
                  {match?.competitors !== null && (
                    <div className="leg_body" key={match?.id}>
                      <div
                        className="leg_row rugby_leg_row finesh false"
                        onClick={() => handleClick(sport, match)}
                        style={{ cursor: "pointer" }}
                      >
                        <span className="match_list_date_status">
                          <span className="status_wrp">
                            {match?.st === "Delayed" && (
                              <span className="status">Dly</span>
                            )}
                            {match?.st === "Postponed" && (
                              <span className="sts_tg red ">PPD</span>
                            )}
                            {match?.st === "Abandoned" && (
                              <span className="sts_tg red">AB</span>
                            )}
                            {match?.st === "Cancelled" && (
                              <span className="sts_tg red">AB</span>
                            )}

                            {match?.st === "Finished" &&
                              match?.mins === "To Finish" ? (
                              <span className="status">To FT</span>
                            ) : (
                              match?.st === "Finished" &&
                              match?.mins === "FAP" && (
                                <span className="status red">FAP</span>
                              )
                            )}
                            {match?.st === "TF" && (
                              <span className="status red">TF</span>
                            )}
                            {match?.st === "Finished" &&
                              match?.mins !== "FAP" &&
                              match?.mins !== "FAET" && (
                                <span className="sts_tg">Finished</span>
                              )}

                            {match?.st === "Finished" &&
                              match?.mins === "FAET" && (
                                <span className="sts_tg">FAET</span>
                              )}
                            {match?.st === "NSY" && (
                              <span className="sts_tg">NSY</span>
                            )}
                            <span className="status">
                              {`${DateUtility.dateFormat1(match?.dt)} ${matchType === "upcoming" &&
                                match?.st !== "Postponed" &&
                                match?.st !== "Abandoned" &&
                                match?.st !== "Cancelled"
                                ? "|"
                                : ""
                                }`}
                            </span>
                            {matchType === "upcoming" &&
                              match?.st !== "Postponed" &&
                              match?.st !== "Abandoned" &&
                              match?.st !== "Cancelled" && (
                                <span className="date">
                                  {DateUtility.ConvertCETtoCurrentTimeZone(
                                    match?.dt,
                                    difference
                                  )}
                                </span>
                              )}
                          </span>
                        </span>

                        <div className="leg_inf_inner">
                          <div className="leg_inf">
                            <div className="cl_team">
                              <span className="flag">
                                <NextImage

                                  src={getImageUrl('', '', sport, match?.competitors?.htid)}
                                  height={23}
                                  width={23}
                                  alt="teamLogo"
                                  priority={false}
                                />
                              </span>
                              <span className="team_name">
                                <span
                                  className={`name ${score?.split("-")[0] > score?.split("-")[1]
                                    ? "font-weight-bold"
                                    : ""
                                    }`}
                                >
                                  {match?.competitors?.htn}
                                </span>
                              </span>
                            </div>
                            <div className="cl_score">
                              {match?.st === "NSY" ||
                                match?.st === "Delayed" ||
                                match?.st === "Result Only" ? (
                                <span className="vs">VS</span>
                              ) : (
                                <MatchScores
                                  score={score}
                                  key={score}
                                  winner={winner}
                                />
                              )}
                            </div>
                            <div className="cl_team snd_team pr_p">
                              <span className="flag">
                                <NextImage
                                  src={getImageUrl('', '', sport, match?.competitors?.atid)}

                                  height={23}
                                  width={23}
                                  alt="teamLogo"
                                  priority={false}
                                />
                              </span>
                              <span className="team_name">
                                <span
                                  className={`name ${score?.split("-")[0] > score?.split("-")[1]
                                    ? "font-weight-bold"
                                    : ""
                                    }`}
                                >
                                  {match?.competitors?.atn}
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              );
            })}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Matches;
